import axios from 'axios';
import Swal from 'sweetalert2';

// ----------------------------------------------------------------------

const inventoryAxiosInstance = axios.create({
  baseURL: process.env.NODE_ENV === 'production' 
    ? process.env.REACT_APP_INVETORY_API_PROD 
    : process.env.REACT_APP_INVETORY_API
});

// Request interceptor
inventoryAxiosInstance.interceptors.request.use(function (req) {
  const accessToken = window.localStorage.getItem('invhash');
  if (accessToken) {
    req.headers.authorization = `Bearer ${accessToken}`;
  }
  return req;
});

inventoryAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const invHash = localStorage.getItem("invhash")
    if (error.response && error.response.status === 401) {
      if(invHash === undefined || invHash === 'undefined' || invHash === '') {
        Swal.fire({
          title: 'Error',
          icon: 'error',
          text: 'Could not connect to inventory. Please re-connect.',
          showCloseButton: true,
          showCancelButton: false,
          confirmButtonColor: '#219653',
          confirmButtonText: 'Re-Connect',
          backdrop: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        .then((status) => {
          if(status.isConfirmed) {
            window.location.reload()
          }
        });
      }
    }
    return Promise.reject((error.response && error.response.data));
  }
);

export default inventoryAxiosInstance;